import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './components/Login/AuthContext';


import './styles/button.css'
import './styles/style.css'
import './styles/form.css'

import Astra from './components/App/Astra';
import Compatibility from './components/App/Compatibility';
import Database from './components/App/Database';
import UIDemo from './components/UI/UIDemo';
import ScrollToTop from './components/Utils/ScrollToTop';
import LandingPage from './components/Page/LandingPage';
import NotFound from './components/Page/NotFound';
import HoroscopePage from './components/Horoscope/HoroscopePage';

// Import blog components
import { 
  MoonArticle, SunArticle, MercuryArticle, VenusArticle, 
  MarsArticle, JupiterArticle, SaturnArticle, UranusArticle, 
  NeptuneArticle, PlutoArticle, BlogIndex,
  // Import signes du zodiaque articles
  BelierArticle, TaureauArticle, GemeauxArticle, CancerArticle,
  LionArticle, ViergeArticle, BalanceArticle, ScorpionArticle,
  SagittaireArticle, CapricorneArticle, VerseauArticle, PoissonsArticle,
  // Import maisons astrologiques articles
  Maison1Article, Maison2Article, Maison3Article, Maison4Article, Maison5Article, Maison6Article, Maison7Article, Maison8Article, Maison9Article, Maison10Article, Maison11Article, Maison12Article
} from './components/Blog';
import { SigneLePlusDifficileArticle, SigneLePlusIntelligentArticle } from './components/Blog/astrologie';

const AppRouter = () => {

    const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

    // Ajout d'un effet pour sauvegarder la page actuelle si non authentifié
    // useEffect(() => {
    //     if (!isAuthenticated && window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
    //         sessionStorage.setItem('redirectUrl', window.location.pathname);
    //     }
    // }, [isAuthenticated]);

    return (
        <Router>
            <ScrollToTop />
            <Routes>

                <Route
                    path="/"
                    element={<LandingPage />}
                />
                <Route
                    path="/calcul-theme-astral"
                    element={<Astra />}
                />
                <Route
                    path="/calcul-theme-astral/:guid/"
                    element={<Astra />}
                />
                <Route
                    path="/compatibilite-amoureuse-astrologie"
                    element={<Compatibility />}
                />
                <Route
                    path="/compatibilite-amoureuse-astrologie/:guid/"
                    element={<Compatibility />}
                />
                <Route
                    path="/database"
                    element={<Database />}
                />
                
                {/* Horoscope Route */}
                <Route
                    path="/horoscope-hebdomadaire"
                    element={<HoroscopePage />}
                />
                
                {/* UI Demo Route */}
                <Route
                    path="/ui-demo"
                    element={<UIDemo />}
                />

                {/* Blog Routes */}
                <Route
                    path="/blog"
                    element={<BlogIndex />}
                />
                {/* Astrologie (général) */}
                <Route
                    path="/blog/astrologie/signe-le-plus-difficile"
                    element={<SigneLePlusDifficileArticle />}
                />
                <Route
                    path="/blog/astrologie/signe-le-plus-intelligent"
                    element={<SigneLePlusIntelligentArticle />}
                />
                <Route
                    path="/blog/planetes/lune"
                    element={<MoonArticle />}
                />
                <Route
                    path="/blog/planetes/soleil"
                    element={<SunArticle />}
                />
                <Route
                    path="/blog/planetes/mercure"
                    element={<MercuryArticle />}
                />
                <Route
                    path="/blog/planetes/venus"
                    element={<VenusArticle />}
                />
                <Route
                    path="/blog/planetes/mars"
                    element={<MarsArticle />}
                />
                <Route
                    path="/blog/planetes/jupiter"
                    element={<JupiterArticle />}
                />
                <Route
                    path="/blog/planetes/saturne"
                    element={<SaturnArticle />}
                />
                <Route
                    path="/blog/planetes/uranus"
                    element={<UranusArticle />}
                />
                <Route
                    path="/blog/planetes/neptune"
                    element={<NeptuneArticle />}
                />
                <Route
                    path="/blog/planetes/pluton"
                    element={<PlutoArticle />}
                />
                
                {/* Routes des signes du zodiaque */}
                <Route
                    path="/blog/signes/belier"
                    element={<BelierArticle />}
                />
                <Route
                    path="/blog/signes/taureau"
                    element={<TaureauArticle />}
                />
                <Route
                    path="/blog/signes/gemeaux"
                    element={<GemeauxArticle />}
                />
                <Route
                    path="/blog/signes/cancer"
                    element={<CancerArticle />}
                />
                <Route
                    path="/blog/signes/lion"
                    element={<LionArticle />}
                />
                <Route
                    path="/blog/signes/vierge"
                    element={<ViergeArticle />}
                />
                <Route
                    path="/blog/signes/balance"
                    element={<BalanceArticle />}
                />
                <Route
                    path="/blog/signes/scorpion"
                    element={<ScorpionArticle />}
                />
                <Route
                    path="/blog/signes/sagittaire"
                    element={<SagittaireArticle />}
                />
                <Route
                    path="/blog/signes/capricorne"
                    element={<CapricorneArticle />}
                />
                <Route
                    path="/blog/signes/verseau"
                    element={<VerseauArticle />}
                />
                <Route
                    path="/blog/signes/poissons"
                    element={<PoissonsArticle />}
                />
                
                {/* Routes des maisons astrologiques */}
                <Route
                    path="/blog/maisons/maison-1"
                    element={<Maison1Article />}
                />
                <Route
                    path="/blog/maisons/maison-2"
                    element={<Maison2Article />}
                />
                <Route
                    path="/blog/maisons/maison-3"
                    element={<Maison3Article />}
                />
                <Route
                    path="/blog/maisons/maison-4"
                    element={<Maison4Article />}
                />
                <Route
                    path="/blog/maisons/maison-5"
                    element={<Maison5Article />}
                />
                <Route
                    path="/blog/maisons/maison-6"
                    element={<Maison6Article />}
                />
                <Route
                    path="/blog/maisons/maison-7"
                    element={<Maison7Article />}
                />
                <Route
                    path="/blog/maisons/maison-8"
                    element={<Maison8Article />}
                />
                <Route
                    path="/blog/maisons/maison-9"
                    element={<Maison9Article />}
                />
                <Route
                    path="/blog/maisons/maison-10"
                    element={<Maison10Article />}
                />
                <Route
                    path="/blog/maisons/maison-11"
                    element={<Maison11Article />}
                />
                <Route
                    path="/blog/maisons/maison-12"
                    element={<Maison12Article />}
                />
                
                {/* <Route
                    path="/legal"
                    element={<Legal />}
                />
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Login />}
                />
                <Route
                    path="/signup"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Signup />}
                />
                <Route
                    path="/login_with_token"
                    element={isAuthenticated ? <Navigate to="/app" /> : <LoginWithToken />}
                /> */}
                {/* <Route
                    path="/tools/generate_ebook"
                    element={<PublicGenerator />}
                /> */}
                
                {/* Page 404 - Wildcard route pour toutes les autres URLs */}
                <Route
                    path="*"
                    element={<NotFound />}
                />
            </Routes>
        </Router>
    );
};

export default AppRouter;
